import React from 'react'
import { useLocation } from 'react-router-dom'
import PlaceholderPage from './PlaceholderPage'
import { lookupPageMeta } from '../../app/pageRegistry'

export default function AutoPlaceholder() {
  const { pathname } = useLocation()
  const meta = React.useMemo(() => lookupPageMeta(pathname), [pathname])
  return <PlaceholderPage title={meta.title} description={meta.description} />
}
